import type { ButtonHTMLAttributes, ReactNode } from "react";

import { Icon, type IconName } from "./Icon";

type Size = "sm" | "md" | "lg";
type Variant = "ghost" | "default";

export interface IconBtnProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "size" | "name"> {
  name: IconName;
  size?: Size;
  variant?: Variant;
  label?: string;
}

const DIM: Record<Size, { box: string; icon: number }> = {
  sm: { box: "w-[22px] h-[22px]", icon: 13 },
  md: { box: "w-7 h-7", icon: 14 },
  lg: { box: "w-8 h-8", icon: 16 },
};

const VARIANT: Record<Variant, string> = {
  ghost: "bg-transparent text-n-600 border-transparent hover:bg-n-100",
  default: "bg-white text-n-700 border-n-200 hover:bg-n-50",
};

export function IconBtn({
  name,
  size = "md",
  variant = "ghost",
  label,
  className = "",
  type = "button",
  ...rest
}: IconBtnProps): ReactNode {
  const d = DIM[size];
  return (
    <button
      {...rest}
      type={type}
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-2 border transition-colors ${d.box} ${VARIANT[variant]} ${className}`}
    >
      <Icon name={name} size={d.icon} />
    </button>
  );
}
